(ns practitest.frontend.common.service-now
  (:require [clojure.string :as str]))

(def search-min-chars 3)

(defn search-term-long-enough? [term]
  (>= (count (str/trim (or term ""))) search-min-chars))

;; A zero-match response comes back from Rails as {"data" []} (ActiveModelSerializers' json_api
;; adapter wraps an empty array it can't otherwise introspect) instead of a plain [] - unwrap that
;; shape so callers always get a plain seq of {:id :name} maps.
(defn unwrap-types-response [response]
  (if (map? response) (:data response) response))
